import { render, staticRenderFns } from "./spog-homepage.vue?vue&type=template&id=48cdf25e&scoped=true&"
import script from "./spog-homepage.vue?vue&type=script&lang=tsx&"
export * from "./spog-homepage.vue?vue&type=script&lang=tsx&"
import style0 from "./spog-homepage.vue?vue&type=style&index=0&id=48cdf25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cdf25e",
  null
  
)

export default component.exports